/* Product page: variant pills, price, sold-out state, quantity stepper, ?variant= in the URL.
   Adding to the order is chk-cart.js (it listens for submit on form[data-product-form]). */
(function () {
  'use strict';

  var form = document.querySelector('form[data-product-form]');
  if (!form) return;

  var variants = [];
  try {
    var data = document.querySelector('script[data-product-variants]');
    variants = JSON.parse(data ? data.textContent : '[]') || [];
  } catch (e) { variants = []; }

  var idInput = form.elements.id;
  var qtyInput = form.elements.quantity;
  var submit = form.querySelector('[data-product-submit]');
  var priceEl = form.querySelector('[data-product-price]');
  var perEl = form.querySelector('[data-product-per]');
  var errEl = form.querySelector('[data-product-error]');
  var minQty = Math.max(1, parseInt(form.getAttribute('data-min-qty'), 10) || 1);
  var fieldsets = Array.prototype.slice.call(form.querySelectorAll('fieldset[data-option-index]'));

  function selectedOptions() {
    return fieldsets.map(function (fs) {
      var on = fs.querySelector('input[type=radio]:checked');
      return on ? on.value : null;
    });
  }

  function findVariant() {
    var chosen = selectedOptions();
    if (!fieldsets.length) return variants[0] || null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (v.options[j] !== chosen[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function render() {
    var v = findVariant();
    var available = !!(v && v.available);
    var market = !!(v && v.market);

    if (idInput) idInput.value = v ? v.id : '';
    if (priceEl) priceEl.textContent = !v ? 'Unavailable' : market ? 'Market price — we’ll confirm cost' : v.price;
    if (perEl) perEl.hidden = !v || market;
    if (submit) {
      submit.disabled = !available;
      submit.textContent = available ? 'Add to order' : 'Sold out';
    }
    if (errEl) errEl.textContent = '';

    if (v && window.history && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.toString());
      } catch (e) { /* the URL just stays as it was */ }
    }
  }

  function clampQty(n) {
    n = Math.floor(Number(n));
    return isNaN(n) || n < minQty ? minQty : n;
  }

  fieldsets.forEach(function (fs) { fs.addEventListener('change', render); });

  if (qtyInput) {
    qtyInput.value = clampQty(qtyInput.value);
    qtyInput.addEventListener('change', function () { qtyInput.value = clampQty(qtyInput.value); });
    form.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var n = clampQty(qtyInput.value);
      qtyInput.value = minus ? Math.max(minQty, n - 1) : n + 1;
    });
  }

  // Keep the min quantity if the browser restores an old value on back/forward.
  window.addEventListener('pageshow', function () { if (qtyInput) qtyInput.value = clampQty(qtyInput.value); });
})();
